import { useEffect } from 'react';

/**
 * Set `document.title` for the lifetime of the component, restoring the
 * previous value on unmount. Avoids the react-helmet-async dep for what
 * is essentially a one-line side effect.
 *
 * Use one per page component. Title strings are intentionally hand-written
 * per page (not derived from a route map) so SEO copy can be tuned on a
 * per-page basis without coupling pages to the router config.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
